import { render } from "./VabeneIntegrationsPage.vue?vue&type=template&id=b7a47e86&scoped=true&ts=true"
import script from "./VabeneIntegrationsPage.vue?vue&type=script&lang=ts"
export * from "./VabeneIntegrationsPage.vue?vue&type=script&lang=ts"

import "./VabeneIntegrationsPage.vue?vue&type=style&index=0&id=b7a47e86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a47e86"]])

export default __exports__